<!-- 预付款结算 -->
<template>
    <div class='page_content'>
        <div class="content" v-if="showTable">
            <el-card class="box-card" style="margin-right: 10px;">
                <div slot="header" class="clearfix ">
                    <v-search :searchList="pageShowData.jurFormVoList.filter(item => item.jciId == 107796)[0].jurconfigform" :getRequestData="getRequestData" @searchData="searchData" @openSearch="openSearch">
                    </v-search>
                </div>
                <div style="height: 31.33px;"></div>
                <el-table class="table1" @selection-change="handleSelectionChange" stripe :data="tableData" :height="tableHeight" border style="width: 100%" highlight-current-row size="mini">
                    <el-table-column fixed="left" type="selection" width="40"></el-table-column>
                    <template v-for="(tableValye, tableKey) in pageShowData.jurFormVoList.filter(item => item.jciId == 107797)[0].jurconfigform">
                        <el-table-column align="center" v-if="tableValye.isShow == 1" :sortable="tableValye.fieldType == 'date' ? true : false" :key="tableKey" show-overflow-tooltip :min-width="tableValye.fieldWeight"
                                         :prop="tableValye.entityField" :label="tableValye.showField">
                            <template slot-scope="scope">
                                <span v-if="tableValye.fieldType == 'date' && scope.row[tableValye.entityField]">
                                    {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
                                </span>
                                <span v-else-if="tableValye.fieldType == 'dateTime' && scope.row[tableValye.entityField]">
                                    {{ $common.getLocalTime(scope.row[tableValye.entityField], true) }}
                                </span>
                                <el-input v-else-if="tableValye.isChange == 1" clearable v-model="scope.row[tableValye.entityField]" :ref="tableValye.entityField" :id="tableValye.entityField"
                                          :disabled="tableValye.isChange == 0">
                                </el-input>
                                <el-tag size="mini" v-else-if="tableValye.entityField == 'isWms'">
                                    {{ scope.row.isWms == 0 ? '否' : '是' }}
                                </el-tag>
                                <span v-else-if="tableValye.isRift == 1">
                                    <a @click="toDetail(scope.row[tableValye.riftField])">{{
                                    scope.row[tableValye.entityField] }}</a>
                                </span>
                                <el-tag size="mini" v-else-if="tableValye.entityField == 'woamState'">{{
                                $common.getIsGsp(tableValye.formatterContent, scope.row.woamState) }}</el-tag>
                                <span v-else>
                                    {{ scope.row[tableValye.entityField] }}
                                </span>
                            </template>
                        </el-table-column>
                    </template>
                </el-table>
                <div class="bottom"><v-pagination :page="getRequestData.page" :rows="getRequestData.rows" :total="total" @setDataPageSize="setDataPageSize" @setDataPageNumber="setDataPageNumber"></v-pagination>
                </div>
            </el-card>
            <el-card class="box-card">
                <div slot="header" class="clearfix">
                    <v-search :searchList="pageShowData.jurFormVoList.filter(item => item.jciId == 107798)[0].jurconfigform" :getRequestData="getRequestData1" @searchData="searchData1" @openSearch="openSearch"
                              :showMx="true" @saveData="saveData" :totalInfo="totalInfo">
                    </v-search>
                </div>
                <div style="display: flex; justify-content: flex-end">
                    <div>
                        <span style="font-size: 20px;">预付金额: <span>{{ totalInfo.settleMoney }}</span></span> <span style="margin-left: 10px;font-size: 20px;">结算总金额: <span>{{ totalInfo.totalMoney}}</span></span>
                    </div>
                </div>
                <el-table :row-style="rowStyle" @selection-change="changeChoice" class="table1" ref="tableData1" :data="tableData1" :height="tableHeight1" border style="width: 100%" size="mini"
                          @sort-change="handleSortChange">
                    <el-table-column type="selection" width="40"></el-table-column>
                    <template v-for="(tableValye, tableKey) in pageShowData.jurFormVoList.filter(item => item.jciId == 107799)[0].jurconfigform">
                        <el-table-column align="center" v-if="tableValye.isShow == 1" :sortable="tableValye.fieldType == 'date' ? true : false" :key="tableKey" show-overflow-tooltip :min-width="tableValye.fieldWeight"
                                         :prop="tableValye.entityField" :label="tableValye.showField">
                            <template slot-scope="scope">
                                <span v-if="tableValye.fieldType == 'date'">
                                    <span v-if="scope.row[tableValye.entityField]">
                                        {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
                                    </span>
                                </span>
                                <span v-else-if="tableValye.chineseField == '业务单号'" style="color: blue;cursor: pointer;" @click="seedetail(scope.row.businessId)">
                                    {{ scope.row[tableValye.entityField] }}
                                </span>
                                <el-input v-else-if="tableValye.entityField == 'settleMoney'" v-model="scope.row.settleMoney" @input="settleMoneyJudge(scope.row, scope.row.index)" :ref="tableValye.entityField"
                                          :id="tableValye.entityField" :disabled="tableValye.isChange == 0">
                                </el-input>
                                <el-tag size="mini" v-else-if="tableValye.entityField == 'isWms'">
                                    {{ scope.row.isWms == 0 ? '否' : '是' }}
                                </el-tag>
                                <span v-else-if="tableValye.isRift == 1">
                                    <a @click="toDetail(scope.row[tableValye.riftField])">{{
                                    scope.row[tableValye.entityField] }}</a>
                                </span>
                                <el-tag size="mini" v-else-if="tableValye.entityField == 'woamState'">{{
                                $common.getIsGsp(tableValye.formatterContent, scope.row.woamState) }}</el-tag>
                                <span v-else>
                                    {{ scope.row[tableValye.entityField] }}
                                </span>
                            </template>
                        </el-table-column>
                    </template>
                </el-table>
                <div class="bottom"><v-pagination :page="getRequestData1.page" :rows="getRequestData1.rows" :total="total1" @setDataPageSize="setDataPageSize1" @setDataPageNumber="setDataPageNumber1"></v-pagination>
                </div>
            </el-card>
        </div>
        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth">
            <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
        </el-dialog>
        <el-dialog :title="seTitle" v-if="showDetail" :visible.sync="showDetail" width="70%">
            <el-table class="table1" stripe :data="detailData" :height="tableHeight" border style="width: 100%" highlight-current-row size="mini">
                <template v-for="(tableValye, tableKey) in pageShowData.jurFormVoList.filter(item => item.jciId == 107800)[0].jurconfigform">
                    <el-table-column align="center" v-if="tableValye.isShow == 1" :key="tableKey" show-overflow-tooltip :min-width="tableValye.fieldWeight" :prop="tableValye.entityField" :label="tableValye.showField">
                        <template slot-scope="scope">
                            <span v-if="tableValye.fieldType == 'date'">
                                <span v-if="scope.row[tableValye.entityField]">
                                    {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
                                </span>
                            </span>
                            <el-tag size="mini" v-else-if="tableValye.entityField == 'isWms'">
                                {{ scope.row.isWms == 0 ? '否' : '是' }}
                            </el-tag>
                            <span v-else-if="tableValye.isRift == 1">
                                <a @click="toDetail(scope.row[tableValye.riftField])">{{ scope.row[tableValye.entityField]}}</a>
                            </span>
                            <el-tag size="mini" v-else-if="tableValye.entityField == 'woamState'">{{$common.getIsGsp(tableValye.formatterContent, scope.row.woamState) }}</el-tag>
                            <span v-else>{{ scope.row[tableValye.entityField] }}</span>
                        </template>
                    </el-table-column>
                </template>
            </el-table>
        </el-dialog>
        <!-- 自定义设计 -->
        <customDesign ref="customDesign"></customDesign>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import SearchScheme from "../../../byComponents/SearchScheme.vue";
import ExtractionScheme from "../../../byComponents/ExtractionScheme.vue";
import NP from "number-precision";
export default {
    //import引入的组件需要注入到对象中才能使用
    components: {
        SearchScheme,
        ExtractionScheme,
    },
    data() {
        //这里存放数据
        return {
            detailData: [],
            showDetail: false,
            seTitle: "",
            DialogVisible: false,
            seWidth: 0,
            parentSearchData: {},
            tableData: [],
            formInline: {},
            tableData1: [],
            formInline1: {},
            tableHeight: 0,
            tableHeight1: 0,
            total: 0,
            total1: 0,
            pageShowData: {},
            getRequestData: {
                rgamRapcus: "",
                rgamPurchaser: "",
                rgamRapcusName: "",
                page: 1,
                rows: 30,
                start: "",
                end: '',
                smName: "",
                coName: "",
                coId: "",
            },
            getRequestData1: {
                rgamRapcus: "",
                rgamPurchaser: "",
                rgamRapcusName: "",
                page: 1,
                rows: 30,
                start: "",
                end: '',
                smName: "",
                coName: "",
                coId: "",
            },
            totalInfo: {
                totalMoney: 0,//结算总金额
                settleMoney: 0,//预付金额
            },
            leftSelectData: [],//左侧选择的数据
            multipleSelection: [],
            returnData: {
                pages: 0, // 总页数
                total: 0, // 总条数
                pageNum: 0, // 当前页数
                list: [],
            },
            showTable: false
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {
        tableData1: {
            handler: function (nvl, ovl) {
                this.totalInfo.totalMoney = nvl.reduce((prev, item) => {
                    prev += +item.settleMoney || 0;
                    return prev;
                }, 0);
                this.totalInfo.totalMoney = NP.round(this.totalInfo.totalMoney, 2)
            },
            deep: true,
            immediate: true,
        },
    },
    //方法集合
    methods: {
        handleSelectionChange(val) {
            this.leftSelectData = val;
            console.log(this.leftSelectData);

            var arr = this.leftSelectData.filter(item => this.leftSelectData[0].coId !== item.coId || this.leftSelectData[0].smId !== item.smId || this.leftSelectData[0].salesId !== item.salesId || this.leftSelectData[0].opmId !== item.opmId)
            console.log(arr);

            if (arr.length > 0) {
                this.totalInfo.settleMoney = 0
                this.totalInfo.totalMoney = 0
                this.tableData1 = []
                this.total1 = 0
                return this.$message.error("只能选择同货主、同供应商、同业务员、同对方业务员的订单！");
            }
            this.totalInfo.settleMoney = this.leftSelectData.reduce((sum, item) => {
                return NP.plus(sum, item.settlementBalance);
            }, 0);
            this.totalInfo.settleMoney = this.$common.getDecimalInfo(3, this.totalInfo.settleMoney);
            if (val.length >= 0) {
                this.searchData1();
            }
        },
        handleSortChange({ column, prop, order }) {
            console.log(`排序字段: ${prop}, 排序方向: ${order}`);
            // 根据排序结果对tableData进行排序操作
            this.tableData1.sort((a, b) => {
                if (order === 'ascending') {
                    return a[prop] > b[prop] ? 1 : -1;
                } else if (order === 'descending') {
                    return a[prop] < b[prop] ? 1 : -1;
                } else {
                    return 0;
                }
            });
        },
        settleMoneyJudge(row, index) {
            let trimmedStr = ""
            if (row.settleMoney.length >= 2 && row.settleMoney[1] !== '.') {
                // 使用正则表达式匹配开头的零，并替换为空字符串
                trimmedStr = row.settleMoney.replace(/^0+/, '');
                row.settleMoney = trimmedStr
            }
            const regex = /^(-?)(?:\d+(\.\d*)?|\.\d+)$/;//判断输入是否是带有小数点的正数或者负数
            if (!regex.test(row.settleMoney)) {
                if (row.settleMoney == '-' || row.settleMoney == '') {

                } else {
                    this.$message.warning("请输入正确的数字")
                    return
                }
            }
            if (row.settleMoney != '-') {
                if (row.settlementBalance <= 0) {
                    if (row.settlementBalance <= row.settleMoney && row.settleMoney <= 0) {
                        this.$refs.tableData1.toggleRowSelection(row, true);
                    } else {
                        this.$refs.tableData1.toggleRowSelection(row);
                        this.$set(this.tableData1[index], "settleMoney", '')
                    }
                } else {
                    if (row.settlementBalance >= row.settleMoney && row.settleMoney >= 0) {
                        this.$refs.tableData1.toggleRowSelection(row, true);
                    } else {
                        this.$refs.tableData1.toggleRowSelection(row);
                        this.$set(this.tableData1[index], "settleMoney", '')
                    }
                }
            }

        },
        changeChoice(val) {
            this.multipleSelection = val
            this.tableData1.forEach(item => {
                if (item.settleMoney == "") {
                    item.settleMoney = 0
                }
                var arr = this.multipleSelection.filter(val => item.businessId == val.businessId)
                if (arr && arr.length > 0) {
                    if (item.settleMoney == 0) {
                        item.settleMoney = item.settlementBalance
                    }
                }
            });

        },
        toDetail(orderId) {
            console.log(orderId)
            if (orderId) {
                // 设置为true 打开穿透组件首页
                var isPenetrate = true;
                // 设置缓存 存入点击单号
                this.resetSetItem("penetrateOrderId", orderId);
                // 与父级跨域通信 传递isPenetrate参数
                window.parent.postMessage(
                    {
                        //向窗口发送MessageEvent消息
                        cmd: "returnFormJson",
                        params: { isPenetrate }, //参数
                    },
                    "*"
                );
            }
        },

        rowStyle({ row, rowIndex }) {
            if (row.settleMoney) {
                return {
                    'background-color': '#0089ff82',
                }
            } else {
                return {}
            }

        },
        async saveData() {
            if (this.totalInfo.totalMoney <= 0) {
                return this.$message.error("结算总金额不能小于0！");
            }
            if (this.totalInfo.totalMoney > this.totalInfo.settleMoney) {
                return this.$message.error("结算总金额不能大于付款余额！");
            }
            let responseData = await this.$http.registeraddPreReconSettle({
                pprmIds: this.leftSelectData.map(item => item.pprmId),
                presettleDetailAdds: this.tableData1.filter(item => {
                    return item.settleMoney;
                }).map(item => {
                    return {
                        businessId: item.businessId,
                        settleMoney: item.settleMoney,
                        settlementBalance: item.settlementBalance
                    }
                }),
                settleMoney: this.totalInfo.totalMoney,
            });
            if (responseData.status == 200) {
                this.$message({
                    message: responseData.message,
                    type: "success",
                });
                this.getDataList();
                this.searchData1();
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        changeInputModel(val) {
            if (val != "" || val != undefined) {
                this.DialogVisible = false;
                this.paramValue(val);
            }
        },
        getSeWidth(e) {
            console.log(e);
            this.seWidth = e + "%";
        },
        getWidth(e) {
            console.log(e);
            this.exWidth = e + "%";
        },
        getSearchName(e) {
            console.log(e);
            this.seTitle = e;
        },
        openSearch({ sId, index, type, sField }) {
            this.seId = sId;
            this.sField = sField;
            this.DialogVisible = true;
            this.parentSearchData[type] = this.getRequestData[type];
        },
        async seedetail(businessId) {
            let responseData = await this.$http.queryPsaccountDetailList({
                ids: [businessId],
            });
            if (responseData.status == 200) {
                this.detailData = responseData.result;
                this.showDetail = true;
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        // 赋值字段
        paramValue(val) {
            let arr = this.sField.split(",");
            arr.forEach((item) => {
                this.getRequestData[item] = val[item];
            });
        },

        // 获取数据列表
        async getPageInfo() {
            var pathId = parent.getMenuInfo(this.$route.path);
            let responseData = await this.$http.getJur({
                ids: [pathId.jurId],
            });
            this.addYuFukuanForm =
                responseData.result.jurFormVoList[0].jurconfigform;
            if (responseData.status == 200) {
                this.getButtonList();
                this.pageShowData = responseData.result;
                this.formDataList = this.pageShowData.jurFormVoList;
                var obj = {};
                if (this.pageShowData.jurHead) {
                    obj = this.$common.getSearchData(
                        this.pageShowData.jurHead.jurconfigform,
                        "page",
                        "rows",
                        30
                    );
                } else {
                    obj = this.$common.getSearch(
                        this.getRequestData1,
                        "start",
                        "end",
                        "page",
                        "rows",
                        30
                    );
                }
                for (const key in obj) {
                    this.$set(this.getRequestData1, key, obj[key]);
                }
                this.getDataList();
                this.$http
                    .getJur({
                        ids: ["1613901622380"], //采购结算申请
                    })
                    .then((res) => {
                        this.addCaiGouForm =
                            res.result.jurFormVoList[0].jurconfigform;
                        this.newFormDataList = res.result.jurFormVoList;
                    });
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
            this.showTable = true
        },
        // 数据搜索
        searchData() {
            this.getRequestData.page = 1;
            this.getDataList();
        },
        // 数据翻页
        setDataPageNumber(val) {
            this.getRequestData.page = val;
            this.getDataList();
        },
        // 切换显示条数
        setDataPageSize(val) {
            this.getRequestData.page = 1;
            this.getRequestData.rows = val;
            this.getDataList();
        },
        // 数据搜索
        searchData1() {
            this.getRequestData1.page = 1;
            this.getRequestData1.coId = this.leftSelectData.map(item => item.coId)[0]
            this.getRequestData1.smId = this.leftSelectData.map(item => item.smId)[0]
            this.getRequestData1.salesId = this.leftSelectData.map(item => item.salesId)[0]
            this.getRequestData1.opmId = this.leftSelectData.map(item => item.opmId)[0]
            this.getDataList1();
        },
        // 数据翻页
        setDataPageNumber1(val) {
            this.getRequestData1.page = val;
            this.getDataList1();
        },
        // 切换显示条数
        setDataPageSize1(val) {
            this.getRequestData1.page = 1;
            this.getRequestData1.rows = val;
            this.getDataList1();
        },
        // 获取数据列表
        async getDataList() {
            let responseData = await this.$http.queryWaitPre(this.getRequestData);
            if (responseData.status == 200) {
                this.tableData = this.$common.getIndex(responseData.result.list);
                this.total = responseData.result.total;
            } else {
                this.tableData = [];
                this.total = 0;
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        async getDataList1() {
            let responseData = await this.$http.registerqueryWaitpsRecon(
                this.getRequestData1
            );
            if (responseData.status == 200) {
                this.tableData1 = this.$common.getIndex(responseData.result.list.map((item) => {
                    item.settleMoney = 0;
                    return item;
                }));
                this.total1 = responseData.result.total;
            } else {
                this.tableData1 = [];
                this.total1 = 0;
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        // 获取按钮权限
        async getButtonList() {
            this.buttonList = await this.$common.getActionButton();
            
        },
//获取状态
        getIsGsp(str, val) {
            try {
                if (str.indexOf("[") === -1) return val;
                str && str.replace(/\\/g, "");
                let arr = JSON.parse(str);
                let len = arr.length;
                let newStr = "";
                for (let i = 0; i < len; i++) {
                    if (arr[i].key == val) {
                        newStr = arr[i].value;
                        break;
                    }
                }
                return newStr ? newStr : val;
            } catch (ex) {
                return val;
            }
        },
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.getPageInfo();
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    mounted() { },
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() {
        this.tableHeight =
            document.documentElement.querySelector(".page_content").clientHeight -
            document.documentElement.querySelector(".el-card__header")
                .clientHeight -
            141;
        this.tableHeight1 =
            document.documentElement.querySelector(".page_content").clientHeight -
            document.documentElement.querySelector(".el-card__header")
                .clientHeight -
            141;
    }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.table_content_tag {
    margin-right: 1rem;
}

.content {
    display: flex;
    justify-content: space-between;
}

.box-card {
    flex: 1;
}

.el-tabs--border-card_new {
    height: 85vh;
    overflow-y: scroll;
}

::v-deep .el-card .el-card__body {
    padding-top: 0;
}

::v-deep .el-card .el-card__header {
    padding-bottom: 10px;
}
</style>